module.exports = __webpack_public_path__ + "static/6-1200-96020a5532c9610ff04c68ca920f4032.png";